import {
  clearLocalStorage,
  getLocalStorage,
  setLocalStorage,
  localStorageDictionary,
} from '../../../localStorage';

type PortalPreference = {
  language?: 'en' | 'fr';
};

/**
 * PreferenceManager
 * Allow to get, set and clear the preference.
 * Persist the preference in the local storage.
 */
class PreferenceManager {
  private preference: PortalPreference | null = null;

  /**
   * Constructor
   * Load the preference from the local storage.
   * If the preference is not found, set it to null.
   */
  constructor() {
    try {
      this.preference = getLocalStorage(
        localStorageDictionary.PORTAL_PREFERENCE,
      );
    } catch (e) {
      this.preference = null;
      throw e;
    }
  }

  /**
   * Get the preference.
   */
  getPreference(): PortalPreference | null {
    return this.preference;
  }

  /**
   * Set the language.
   * @param language
   */
  setLanguage(language: 'en' | 'fr') {
    this.preference = {
      ...this.preference,
      language,
    };
    setLocalStorage(localStorageDictionary.PORTAL_PREFERENCE, this.preference);
  }

  /**
   * Clear the preference.
   */
  clear() {
    this.preference = null;
    clearLocalStorage(localStorageDictionary.PORTAL_PREFERENCE);
  }
}

const preferenceManager = new PreferenceManager();
export default preferenceManager;
